import { GridColumnHeader } from '../components/Grid/types';
import { Attribute, DataSource } from '../types/entities.types';

const gridHeaders: GridColumnHeader[] = [
  {
    name: 'businessMetadata.asset_name',
    label: 'Metric Name',
    width: '30%',
    filter: {
      type: 'text',
      remoteSearchFields: ['asset_name'],
    },
    sortable: true,
    remoteSortField: 'asset_name',
  },
  {
    name: 'sourceSpecificMetadata.MetricCatalog.metric_source',
    label: 'Metric Source',
    width: '25%',
    filter: {
      type: 'aggregation',
      aggregationName: 'metric_source_aggregation',
      remoteSearchFields: ['metric_source'],
      filterSelectProps: {
        isClearable: true,
      },
    },
  },
  {
    name: 'businessMetadata.descriptiveMetadata.description',
    label: 'Description',
    width: '50%',
  },
  { name: 'lineage', label: 'Lineage', width: '10%' },
];

const attributesMap: Attribute[] = [
  {
    name: 'businessMetadata.asset_id',
    label: 'Metric Id',
    showInColumn: 0,
    description: 'Metric id',
  },
  {
    name: 'businessMetadata.asset_name',
    label: 'Metric Name',
    showInColumn: 0,
    description: 'Metric name',
  },
  {
    name: 'businessMetadata.descriptiveMetadata.description',
    label: 'Description',
    showInColumn: 2,
    description: 'Metric description',
  },
  {
    name: 'technicalMetadata.asset_type',
    label: 'Metric Type',
    showInColumn: 0,
    description: 'Metric type',
  },
  {
    name: 'technicalMetadata.created_time',
    label: 'Created Time',
    showInColumn: 0,
    description: 'Created time',
    type: 'date',
  },
  {
    name: 'sourceSpecificMetadata.MetricCatalog.metric_source',
    label: 'Metric Source',
    showInColumn: 0,
    description: 'Metric Source',
  },
  {
    name: 'businessMetadata.administrativeMetadata.technical_data_steward',
    label: 'Technical Data Steward',
    showInColumn: 2,
    type: 'array',
  },
  {
    name: 'sourceSpecificMetadata.MetricCatalog.background_context',
    label: 'Background Context',
    showInColumn: 1,
    description: 'Background Context',
  },
  {
    name: 'sourceSpecificMetadata.MetricCatalog.business_formula',
    label: 'Business Formula',
    showInColumn: 1,
    description: 'Business Formula',
  },
  {
    name: 'sourceSpecificMetadata.MetricCatalog.query',
    label: 'Query',
    showInColumn: 1,
    description: 'query',
    type: 'html',
  },
  {
    name: 'sourceSpecificMetadata.MetricCatalog.metric_classification',
    label: 'Metric Classification',
    showInColumn: 1,
    description: 'metric_classification',
  },
  {
    name: 'sourceSpecificMetadata.MetricCatalog.source_columns',
    label: 'Source Columns',
    showInColumn: 1,
    description: 'source_columns',
    type: 'sourceColumns',
  },
  {
    name: 'sourceSpecificMetadata.MetricCatalog.source_tables',
    label: 'Source Tables',
    showInColumn: 1,
    description: 'source tables',
    type: 'array',
  },
  {
    name: 'sourceSpecificMetadata.MetricCatalog.data_domains',
    label: 'Data Domains',
    showInColumn: 1,
    description: 'Data Domains',
    type: 'array',
  },
  {
    name: 'sourceSpecificMetadata.MetricCatalog.schema_names',
    label: 'Schema Names',
    showInColumn: 1,
    description: 'Schema Names',
    type: 'array',
  },
  {
    name: 'sourceSpecificMetadata.MetricCatalog.business_data_stewards',
    label: 'Business Data Stewards',
    showInColumn: 1,
    description: 'Business Data Stewards',
    type: 'array',
  },
  {
    name: 'sourceSpecificMetadata.MetricCatalog.business_segments',
    label: 'Business Segments',
    showInColumn: 1,
    description: 'Business Segments',
    type: 'array',
  },
  {
    name: 'sourceSpecificMetadata.MetricCatalog.metric_version',
    label: 'Metric Version',
    showInColumn: 1,
    description: 'Metric Version',
  },
  {
    name: 'sourceSpecificMetadata.MetricCatalog.analysis_type',
    label: 'Analysis Type',
    showInColumn: 1,
    description: 'Analysis Type',
  },
  {
    name: 'sourceSpecificMetadata.MetricCatalog.display_name',
    label: 'Display Name',
    showInColumn: 1,
    description: 'Display Name',
  },
  {
    name: 'sourceSpecificMetadata.MetricCatalog.default_value',
    label: 'Default Value',
    showInColumn: 1,
    description: 'Default Value',
  },
  {
    name: 'sourceSpecificMetadata.MetricCatalog.higher_is_better',
    label: 'Higher is Better?',
    showInColumn: 1,
    description: 'Higher is Better?',
    type: 'boolean',
  },
  {
    name: 'sourceSpecificMetadata.MetricCatalog.experiment_platform',
    label: 'Experiment Platform',
    showInColumn: 1,
    description: 'Experiment Platform',
  },
  {
    name: 'sourceSpecificMetadata.MetricCatalog.dimensions',
    label: 'Dimensions',
    showInColumn: 1,
    description: 'Dimensions',
    type: 'array',
  },
  {
    name: 'sourceSpecificMetadata.MetricCatalog.source_id',
    label: 'Source ID',
    showInColumn: 1,
    description: 'Source ID',
  },
  {
    name: 'sourceSpecificMetadata.MetricCatalog.identifiers',
    label: 'Identifiers',
    showInColumn: 1,
    description: 'Identifiers',
    type: 'array',
  },
  {
    name: 'sourceSpecificMetadata.MetricCatalog.partner',
    label: 'Partner',
    showInColumn: 2,
    description: 'Partner',
  },
];

const customQueryForListPage = `
  MetricCatalog {
    background_context
    business_data_stewards
    business_formula
    business_segments
    data_domains
    metric_classification
    metric_source
    query
    schema_names
    source_columns
    source_tables
  }
`;

const customQueryForDetailsPage = `
  MetricCatalog {
    analysis_type
    background_context
    business_data_stewards
    business_formula
    business_segments
    data_domains
    default_value
    dimensions
    display_name
    experiment_platform
    higher_is_better
    identifiers
    metric_classification
    metric_source
    metric_version
    partner
    query
    schema_names
    source_columns
    source_id
    source_tables
  }
`;

export const MetricCatalogConfig: DataSource = {
  id: '12',
  name: 'MetricCatalog',
  showColumns: false,
  showPartitionColumns: false,
  showLineage: true,
  showLineageTable: false,
  showLineagePipeline: false,
  showLineageQuery: false,
  showLineageCloned: false,
  showLineageCW: false,
  showLineageColumn: false,
  showLineageDashboard: true,
  showDashboards: true,
  gridHeaders,
  attributesMap,
  customQueryForListPage,
  customQueryForDetailsPage,
  label: 'Metrics',
};
